var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#009482;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1169.4,599.244h0a8,8,0,0,0-8,8h0a7.962,7.962,0,0,0,1.006,3.884l4.247-4.247a4.3,4.3,0,0,1,5.826-5.193l-1.74,1.74a1.04,1.04,0,0,0,0,1.471l.75.75a1.04,1.04,0,0,0,1.471,0l1.74-1.74a4.3,4.3,0,0,1-5.193,5.826l-4.314,4.314a7.961,7.961,0,0,0,4.207,1.2h0a8,8,0,0,0,8-8h0A8,8,0,0,0,1169.4,599.244Z",
    transform: "translate(-1161.4 -599.244)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechSupport);
export default __webpack_public_path__ + "static/media/tech-support.41185d4844ba929eeec9e036eed8bd86.svg";
export { ForwardRef as ReactComponent };